export enum Role {
  Agent = 'agent',
  Admin = 'admin',
  Owner = 'owner',
  Chatbot = 'chatbot',
}
